import { IOrganization } from '@dealpoint/types'
import { Alert, AlertTitle, Stack, Typography } from '@mui/material'
import {
  Context,
  Dispatch,
  FC,
  PropsWithChildren,
  ReactNode,
  SetStateAction,
  createContext,
  useState,
} from 'react'

import ConfirmationModal, {
  ConfirmationModalProps,
} from './components/common/Modals/ConfirmationModal'

export interface AppContextProps {
  orgID?: string
  orgInfo?: IOrganization
  userID?: string
  setPrompt?: Dispatch<SetStateAction<Prompt>>
}

export interface Prompt {
  cancelButtonLabel?: string
  cancelButtonProps?: ConfirmationModalProps['cancelButtonProps']
  children?: ReactNode
  confirmButtonLabel?: string
  confirmButtonProps?: ConfirmationModalProps['confirmButtonProps']
  title?: ReactNode
  onCancel: ConfirmationModalProps['onCancel']
  onConfirm: ConfirmationModalProps['onConfirm']
}

const AppContext: Context<AppContextProps> = createContext<AppContextProps>({
  orgID: null,
  orgInfo: null,
  userID: null,
})

export const AppContextProvider: FC<PropsWithChildren<AppContextProps>> = ({
  children,
  orgID,
  orgInfo,
  userID,
}) => {
  const [prompt, setPrompt] = useState<Prompt>()
  const {
    cancelButtonLabel,
    cancelButtonProps,
    children: promptChildren,
    confirmButtonLabel,
    confirmButtonProps,
    title,
    onCancel,
    onConfirm,
  } = prompt ?? {}

  console.log({ orgID, orgInfo })

  return (
    <>
      <AppContext.Provider value={{ orgID, orgInfo, userID, setPrompt }}>
        {children}
      </AppContext.Provider>

      <ConfirmationModal
        cancelButtonLabel={cancelButtonLabel}
        cancelButtonProps={cancelButtonProps}
        confirmButtonLabel={confirmButtonLabel}
        confirmButtonProps={confirmButtonProps}
        open={!!prompt}
        title={title}
        onCancel={onCancel}
        onConfirm={onConfirm}
      >
        {promptChildren ?? defaultChildren}
      </ConfirmationModal>
    </>
  )
}

const defaultChildren = (
  <Stack spacing={2}>
    <Typography fontWeight="bold">Are you sure want to leave?</Typography>

    <Alert severity="warning" variant="standard">
      <AlertTitle>Warning</AlertTitle>

      <Stack spacing={1}>
        <Typography color="inherit">
          You have unsaved changes! Do you wish to save your changes before you leave?
        </Typography>
      </Stack>
    </Alert>
  </Stack>
)

export { AppContext }
